import type { FaireProductEntity } from "../../entity_types/product";

export const p_ezftrpx5yc: FaireProductEntity = {
  token: "p_ezftrpx5yc",
  type: "product",
  name: "California Soy Candle",
  brandToken: "b_yynur8ww",
  brandName: "Good & Well Supply Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/96cb946c6fc02abbbfafdab424f0463caf3d7030583f16346b935d44456dfc61.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/886dcfebef4b5594e7166ed02bccbe8b3735742554a6c707a98b04dfced3ecc0.png",
  ],
  priceDollars: 13,
  description:
    "Notes of orange, bergamot & neroli.\n\nDesigned as a love letter to the places we call home, our 50 States candle collection captures the distinctive essence of each U.S. state through thoughtfully blended fragrances. Each candle draws inspiration from the state’s landscapes, traditions, and signature aromas, creating a nostalgic tribute to the natural elements, scents, and cherished memories that make every state unique.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:04.518Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
